import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {NgClass, NgForOf, NgIf} from "@angular/common";

interface ToggleOption {
  label: string;
  value: any;
  disabled?: boolean;
}

@Component({
  selector: 'app-toggle-button-group',
  standalone: true,
  imports: [
    NgClass,
    NgForOf,
    NgIf
  ],
  templateUrl: './toggle-button-group.component.html',
  styleUrl: './toggle-button-group.component.scss'
})
export class ToggleButtonGroupComponent implements OnInit, OnChanges {

  @Input() label: string = '';
  @Input() options: ToggleOption[] = [];
  @Input() inputType: 'checkbox' | 'radio' = 'checkbox';
  @Input() name: string = '';
  @Input() gridClass: string = 'sm:grid-cols-3';
  @Input() selected: any[] | any = this.inputType === 'checkbox' ? [] : null;

  @Output() selectionChange = new EventEmitter<any[] | any>();

  // Store pre-calculated states
  selectionStates: { [key: string]: boolean } = {};
  selectionStyles: { [key: string]: any } = {};

  ngOnInit() {
    // Only update if we have options
    if (this.options?.length) {
      this.updateSelectionStates();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Only update if selected or options actually changed
    if ((changes['selected'] && !changes['selected'].firstChange) ||
      (changes['options'] && !changes['options'].firstChange)) {
      if (this.options?.length) {
        this.updateSelectionStates();
      }
    }
  }

  private updateSelectionStates() {
    // console.log('[toggle-button-group.component.ts] updateSelectionStates');

    if (!this.options) return;

    if (!this.options) return;

    this.options.forEach((option, index) => {
      // Calculate selection state
      const isOptionSelected = this.inputType === 'radio'
        ? this.selected === option.value
        : Array.isArray(this.selected) && this.selected.includes(option.value);

      this.selectionStates[option.value] = isOptionSelected;

      // Apply special styling for myJudgement, dealStages and dealValues
      if (this.name === 'myJudgement' || this.name === 'dealStages' || this.name === 'dealValues') {
        this.selectionStyles[option.value] = {
          '!text-white': isOptionSelected,
          [`bg-${index === 0 ? 'blue-royal' : index === 1 ? 'indigo-500' : 'violet-500'}`]: isOptionSelected,
          [`bg-${index === 0 ? 'blue-royal' : index === 1 ? 'indigo-500' : 'violet-500'} text-white shadow shadow-${index === 0 ? 'blue-royal' : index === 1 ? 'indigo-500' : 'violet-500'}/10 hover:bg-${index === 0 ? 'blue-royal' : index === 1 ? 'indigo-500' : 'violet-500'}`]: isOptionSelected && !option.disabled,
          'bg-[#fafafe] text-secondary': !isOptionSelected && !option.disabled,
          [`hover:bg-${index === 0 ? 'blue-royal' : index === 1 ? 'indigo-500' : 'violet-500'}`]: isOptionSelected && !option.disabled,
          'hover:bg-[#f6f4ff]': !isOptionSelected && !option.disabled
        };
      } else {
        this.selectionStyles[option.value] = {
          'bg-blue-royal text-white shadow shadow-blue-royal/10 hover:opacity-90': isOptionSelected && !option.disabled,
          'bg-white/75 text-secondary': !isOptionSelected && !option.disabled,
          'hover:bg-blue-royal': isOptionSelected && !option.disabled,
          'hover:bg-white/50': !isOptionSelected && !option.disabled
        };
      }
    });
  }

  onSelectionChange(value: string) {
    let newSelected: string | string[];

    if (this.inputType === 'radio') {
      newSelected = value;
    } else {
      const selectedArray = Array.isArray(this.selected) ? [...this.selected] : [];
      const index = selectedArray.indexOf(value);
      if (index === -1) {
        selectedArray.push(value);
      } else {
        selectedArray.splice(index, 1);
      }
      newSelected = selectedArray;
    }

    // Only update if the selection actually changed
    if (JSON.stringify(this.selected) !== JSON.stringify(newSelected)) {
      this.selected = newSelected;
      this.updateSelectionStates();
      this.selectionChange.emit(this.selected);
    }
  }

  /*
  onSelectionChange(value: string) {
    console.log('[toggle-button-group.component.ts] onSelectionChange')

    if (this.inputType === 'checkbox') {
      const selectedValues = this.selected as string[];
      const index = selectedValues.indexOf(value);

      if (index === -1) {
        this.selectionChange.emit([...selectedValues, value]);
      } else {
        this.selectionChange.emit(selectedValues.filter(v => v !== value));
      }
    } else {
      // For radio, emit the selected value directly
      this.selectionChange.emit(value);
    }

    // Clear the cache after selection changes
    this.selectionCache.clear();
  }
  */

  /*
  isSelected(value: string): boolean {
    console.log('[toggle-button-group] isSelected')

    // Check if we have a cached result
    const cached = this.selectionCache.get(value);
    if (cached !== undefined) {
      return cached;
    }

    let result: boolean;
    if (this.inputType === 'radio') {
      result = this.selected === value;
    } else {
      result = Array.isArray(this.selected) && this.selected.includes(value);
    }

    // Cache the result
    this.selectionCache.set(value, result);
    return result;
  }
  */

}
